import { useState, useEffect } from 'react';
import { apiClient, API_ENDPOINTS } from '../config/api';
import type { MySanctionItem } from '../types/report';

export function useMySanctions() {
  const [sanctions, setSanctions] = useState<MySanctionItem[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);

    apiClient
      .get<{ result: { sanctions: MySanctionItem[] } }>(API_ENDPOINTS.SANCTION.MY_LIST)
      .then((res) => {
        if (!cancelled) setSanctions(res.result.sanctions ?? []);
      })
      .catch((err: any) => {
        if (!cancelled) setError(err.message ?? '제재 내역을 불러오지 못했습니다.');
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return { sanctions, loading, error, hasSanctions: sanctions.length > 0 };
}
